/* KKO³ — Panier : avertissement « retrait uniquement ».
   Se déclenche quand le panier mélange un produit à retirer en boutique
   et des produits livrables. Deux choix : tout retirer, ou retirer la pièce fragile
   du panier pour faire livrer le reste.
   La liste des produits concernés vient de window.KKO_PICKUP_ONLY (collection « Retrait uniquement »). */
(function () {
  if (window.__kkoPickupBound) return;
  window.__kkoPickupBound = true;

  var HANDLES = window.KKO_PICKUP_ONLY || [];
  if (!HANDLES.length) return;
  var STORAGE = 'kko-pickup-ack';

  function isPickup(item){
    return HANDLES.indexOf(item.handle) > -1;
  }

  function style(){
    if (document.getElementById('kko-pickup-style')) return;
    var s = document.createElement('style');
    s.id = 'kko-pickup-style';
    s.textContent =
      '.kko-pknote{margin:14px 0;padding:16px 18px;background:#f6efe9;border-left:3px solid #C24A2E;}' +
      '.kko-pknote__t{display:block;margin-bottom:6px;font-size:11px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:#C24A2E;}' +
      '.kko-pknote__x{margin:0 0 14px;font-size:13.5px;line-height:1.55;color:#4a3728;}' +
      '.kko-pknote__x strong{color:#382B23;}' +
      '.kko-pknote__btns{display:flex;flex-wrap:wrap;gap:8px;}' +
      '.kko-pknote__btn{flex:1 1 auto;padding:11px 14px;border:1px solid #C24A2E;background:#C24A2E;color:#fff;font-size:11px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;cursor:pointer;text-align:center;}' +
      '.kko-pknote__btn:hover{background:#382B23;border-color:#382B23;}' +
      '.kko-pknote__btn--ghost{background:transparent;color:#382B23;border-color:#e0d5c9;}' +
      '.kko-pknote__btn--ghost:hover{background:#382B23;color:#fff;border-color:#382B23;}' +
      '.kko-pknote--ok{border-left-color:#2E7D32;background:#edf4ec;}' +
      '.kko-pknote--ok .kko-pknote__t{color:#1f5c23;}';
    document.head.appendChild(s);
  }

  function removeNotes(){
    document.querySelectorAll('.kko-pknote').forEach(function(n){ n.remove(); });
  }

  function hosts(){
    var list = [];
    var drawer = document.querySelector('.drawer--cart .ajaxcart__inner, .drawer--cart .ajaxcart');
    if (drawer) list.push(drawer);
    var page = document.querySelector('.template-cart .cart__items, .cart-wrapper, main .cart');
    if (page) list.push(page);
    return list;
  }

  function names(items){
    return items.map(function(i){ return i.product_title; }).join(', ');
  }

  function render(cart){
    removeNotes();
    style();
    var pickupItems = cart.items.filter(isPickup);
    if (!pickupItems.length) return;
    var others = cart.items.filter(function(i){ return !isPickup(i); });
    var acked = sessionStorage.getItem(STORAGE) === '1';

    var note = document.createElement('div');
    note.className = 'kko-pknote' + ((!others.length || acked) ? ' kko-pknote--ok' : '');

    if (!others.length || acked) {
      note.innerHTML =
        '<span class="kko-pknote__t">Commande à retirer</span>' +
        '<p class="kko-pknote__x">À la caisse, choisis <strong>Retrait</strong> : ta commande t\'attendra à la chocolaterie, Route d\'Alle 1 à Porrentruy, sous 24 heures.</p>';
    } else {
      note.innerHTML =
        '<span class="kko-pknote__t">Un article se retire en boutique</span>' +
        '<p class="kko-pknote__x"><strong>' + names(pickupItems) + '</strong> voyage mal et se retire à Porrentruy. Une commande part soit en livraison, soit en retrait, jamais les deux. À toi de choisir.</p>' +
        '<div class="kko-pknote__btns">' +
          '<button type="button" class="kko-pknote__btn" data-kko-pk-all>Je viens tout chercher</button>' +
          '<button type="button" class="kko-pknote__btn kko-pknote__btn--ghost" data-kko-pk-drop>Faire livrer le reste</button>' +
        '</div>';
    }

    hosts().forEach(function(h, idx){
      h.insertBefore(idx === 0 ? note : note.cloneNode(true), h.firstChild);
    });
  }

  function refresh(){
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(render)
      .catch(function(){});
  }

  function openDrawerWith(cart){
    document.documentElement.dispatchEvent(new CustomEvent('wetheme-toggle-right-drawer', {
      detail: { type: 'cart', forceOpen: true, params: { cart: cart } }
    }));
  }

  document.addEventListener('click', function(e){
    var all = e.target.closest && e.target.closest('[data-kko-pk-all]');
    var drop = e.target.closest && e.target.closest('[data-kko-pk-drop]');

    if (all){
      sessionStorage.setItem(STORAGE, '1');
      refresh();
      return;
    }

    if (drop){
      drop.disabled = true;
      drop.textContent = '…';
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.json(); })
        .then(function(cart){
          var updates = {};
          cart.items.forEach(function(i){ if (isPickup(i)) { updates[i.key] = 0; } });
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        })
        .then(function(){ return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }); })
        .then(function(cart){
          sessionStorage.removeItem(STORAGE);
          document.querySelectorAll('.kko-hdr__cartcount').forEach(function(b){ b.textContent = cart.item_count; });
          openDrawerWith(cart);
          setTimeout(refresh, 400);
        })
        .catch(function(){
          drop.disabled = false;
          drop.textContent = 'Faire livrer le reste';
        });
    }
  });

  document.documentElement.addEventListener('wetheme-toggle-right-drawer', function(){
    setTimeout(refresh, 350);
  });
  document.addEventListener('kko:cart:added', function(){ setTimeout(refresh, 300); });

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
